import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

// import ShopifyAppLayout from 'components/shopifyApp/ShopifyAppLayout'
import { initShopifyApp } from 'controllers/shopifyApp'
import WizardSkeleton from 'components/shopifyApp/shopifyWizard/Skeleton'

class ShopifyAppRunner extends Component {

  constructor (props) {
    super(props)
    console.log('======> ShopifyAppRunner constructor', Date.now())
    this.state = {
      params: this.getParams(props)
    }
  }

  getParams = (props) => {
    const { location } = props
    if (location.search) {
      const strParams = location.search.substring(1)
      const params = {}
      _.map(_.split(strParams, '&'), str => {
        const pair = _.split(str, '=')
        params[pair[0]] = pair[1]
      })
      console.log('Shopify App constructor', params)
      return params
    } else {
      return {}
    }
  }

  componentWillReceiveProps (nextProps) {
    const { authData, dispatch } = this.props
    const { params } = this.state
    if (authData.initializing && !_.has(nextProps.authData, 'auth.data.initializing')) {
      console.log('======> ShopifyAppRunner initShopifyApp', Date.now())
      dispatch(initShopifyApp(params))
    }
  }

  render () {
    return (
      <WizardSkeleton />
      // <ShopifyAppLayout />
    )
  }
}

ShopifyAppRunner.propTypes = {
  location: PropTypes.object,
  authData: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  authData: state.authData
})

export default connect(mapStateToProps)(ShopifyAppRunner)



// WEBPACK FOOTER //
// ./src/components/pages/ShopifyAppRunner.js